// extracted by mini-css-extract-plugin
export var callCard = "_on-0";
export var callMessageButton = "_on-1";
export var helpIcon = "_on-3";
export var helpIconContainer = "_on-4";
export var verticalDivider = "_on-2";